import React, {useEffect, useState} from "react";
import NavBar from "../NavBar";
import {CampData as IncomingData} from "./CRMData/CRMCampData";
import CardRender from "../DashboardCardRender";
import IDCard  from "./IDcard/CampaignIDCard";
import WideCard from "../WideCard";
import { CRMCampaignsData } from "../CardData";
import { CRMWideCardData } from "../WideCardData";


const CRMCampaigns = ()=>{
    const [count,setCount] = useState([]);
    const [filtr, setFiltr] = useState("");
  const [type, setType] = useState("all");
  const handle1 = () => {
    setType("all");
  };
  const handle2 = () => {
    setType("open");
  };
  const handle3 = () => {
    setType("past");
  };
  useEffect(() => {
    if (type === "open") {
      setCount(
        IncomingData.filter(
          (x) => x.td4 === "Unpaid" || x.td4 === "Overdue"
        )
      );
    } else if (type === "past") {
      setCount(IncomingData.filter((x) => x.td4 === "Paid"));
    } else {
      setCount("");
    }
    setFiltr("");
  }, [type]);

  const handleFilter = (e) => {
    setFiltr(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.Budget < 5000
      } 
      else if (e.target.value === '2') {
        return x.Budget > 50000
      }
      else if (e.target.value === '3') {
        return x.Budget > 100000
      }
    }));
  };

    return(
        <>
        <NavBar />
        <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="business_title">Customer Relationship Management   </span>
          <span className="color"> &#62; </span>
          <span className="color"> Campaigns</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h1>Campaigns</h1>
        <div id="Right-content-Down-Filters">
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "80%",
            }}
          ></div>
        </div>
      </div>
      <div id="click-data" style={{ marginLeft:"1.5rem"}}>
            <p>Active</p>
            <p>Completed</p>
        </div>
      <div id="OMS-main-content">

        <div className="order-list-box" style={{ width: "64%",marginLeft:'1.5rem',marginTop:'0' }}>
          
          <div className="order-list-input-box" style={{width:"auto"}}>
            <div className="order-list-input-left">
              <input type="text" 
                placeholder="Search for campaign name, Headed by"
                onChange={(val) => {
                  setCount(
                    IncomingData.filter((x) =>
                      x.Campaign_ID.match(val.target.value) || x.Headed_By.match(val.target.value)
                    )
                  );
                  setFiltr("");
                setType("all");
                }
                }
              />
              {/* <img src={searchWhiteIcon} alt="" width="" /> */}
            </div>
            <div className="order-list-input-right"  style={{width:"none"}}>
              <select name="" id="" className="order-list-input-right-filters"
              value={filtr}
              onChange={handleFilter}
              >
                <option value="" selected>
                  by budget
                </option>
                <option value="1">&lt;5000</option>
        <option value="2">&gt;50000</option>
        <option value="3">&gt;100000</option>
              </select>
              
            </div>
          </div>
          <table  className="th-light" style={{ textAlign: "center"}}>
            <tr>
              <th>Campaign ID</th>
              <th>Headed By</th>
              <th>Department Name</th>
              <th>Budget</th>
              <th>Started on</th>
              <th>Goals</th>
              <th>Duration</th>
            </tr>
          {count.length>0 ? count.map((val)=>{
            return (
                <tr>
                  <td style={{textDecoration:"underline"}}>{val.Campaign_ID}</td>
                  <td>{val.Headed_By}</td>
                  <td>{val.Department_name}</td>
                  <td>{val.Budget}</td>
                  <td>{val.Started_on}</td>
                  <td>{val.Goals}</td>
                  <td>{val.Duration}</td> 
                </tr>
              );
          })
             : IncomingData.map((val) => {
              return (
                <tr >
                  <td  style={{textDecoration:"underline"}}>{val.Campaign_ID}</td>
                  <td>{val.Headed_By}</td>
                  <td>{val.Department_name}</td>
                  <td>{val.Budget}</td>
                  <td>{val.Started_on}</td>
                  <td>{val.Goals}</td>
                  <td>{val.Duration}</td>
                
                </tr>
              );
            })}
          </table>
        </div>

        {/* card data */}
        <div>
          
          <div style={{display:'flex',gap:"1rem",width:"30rem"}}>
              <CardRender comp={CRMCampaignsData} />
          </div>
            <WideCard data={CRMWideCardData}/>
            <IDCard/>
          </div>
      </div> 
        </>
    );
}

export default CRMCampaigns;